import { useState } from 'react';
import { API_BASE } from '../config';

export default function CategoryManager({ disabled, categories, onSaved, onDeleted, onBusyChange }) {
    const [open, setOpen] = useState(false);
    const [editingId, setEditingId] = useState('');
    const [name, setName] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const save = async event => {
        event.preventDefault();
        if (busy) return;
        if (!name.trim()) return setError('카테고리명을 입력해 주세요.');
        setBusy(true);
        onBusyChange(true);
        setError('');
        try {
            const res = await fetch(`${API_BASE}/api/admin/categories${editingId ? `/${editingId}` : ''}`, {
                method: editingId ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({ name: name.trim() })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || '저장하지 못했습니다.');
            await onSaved(data);
            setEditingId('');
            setName('');
        } catch (err) { setError(err.message); }
        finally { setBusy(false); onBusyChange(false); }
    };
    const remove = async () => {
        const selected = categories.find(c => String(c.category_id) === editingId);
        if (busy || disabled || !selected || selected.is_fixed || ['기본형', '서비스형'].includes(selected.name)) return;
        if (!window.confirm(`‘${selected.name}’ 카테고리를 모든 사업의 공통 목록에서 삭제하시겠습니까?`)) return;
        setBusy(true);
        onBusyChange(true);
        setError('');
        try {
            const res = await fetch(`${API_BASE}/api/admin/categories/${editingId}`, {
                method: 'DELETE', headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || '삭제하지 못했습니다.');
            await onDeleted(selected);
            setEditingId('');
            setName('');
        } catch (err) { setError(err.message); }
        finally { setBusy(false); onBusyChange(false); }
    };
    return <div className="category-management">
        <div className="program-toolbar">
            <button type="button" className="user-input-button" disabled={disabled || busy} aria-expanded={open} onClick={() => setOpen(!open)}>카테고리 관리</button>
            <span>모든 사업에서 공통으로 사용합니다.</span>
        </div>
        {open && <form className="program-editor category-editor" onSubmit={save}>
            <h3>카테고리 관리</h3>
            <p>기본형·서비스형은 수정·삭제할 수 없습니다. 이름 수정은 모든 사업에 반영되며, 사용 중인 카테고리는 삭제할 수 없습니다.</p>
            <fieldset disabled={busy || disabled}>
                <label>관리할 카테고리
                    <select className="user-input" value={editingId} onChange={e => {
                        setEditingId(e.target.value);
                        setName(categories.find(c => String(c.category_id) === e.target.value)?.name || '');
                        setError('');
                    }}>
                        <option value="">새 카테고리 추가</option>
                        {categories.map(c => <option key={c.category_id} value={c.category_id} disabled={c.is_fixed || ["기본형", "서비스형"].includes(c.name)}>{c.name}{c.is_fixed || ["기본형", "서비스형"].includes(c.name) ? " (수정 불가)" : ""}</option>)}
                    </select>
                </label>
                <label>카테고리명
                    <input className="user-input" required maxLength={100} value={name} onChange={e => setName(e.target.value)} />
                </label>
                <div className="program-editor-actions">
                    {editingId && <button type="button" className="user-input-button category-delete-button" onClick={remove}>삭제</button>}
                    <button type="button" className="user-input-button" onClick={() => setOpen(false)}>닫기</button>
                    <button className="user-input-button program-save-button" type="submit">{busy ? '저장 중…' : editingId ? '이름 수정' : '추가'}</button>
                </div>
            </fieldset>
            {error && <p role="alert" className="program-error">{error}</p>}
        </form>}
    </div>;
}
